/**************
 Cart
 ***************/

const freeShipping = freeShippingThreshold * 100;
const freeGift = freeGiftThreshold * 100;
const total = allBenefitsThreshold * 100;
const progressBar = document.getElementById("miniCartTopProgressBar");
const progressText = document.getElementById("miniCartProgressText");
const shippingIcon = document.querySelector('.miniCartProgressBarShipping');
const freeGiftIcon = document.querySelector('.miniCartProgressBarGift');
const percentageIcon = document.querySelector('.miniCartProgressBarPercentage');

// open cart
async function openCart(skipFetch = false) {

    // // reset body container
    document.querySelector("#miniCartBody").innerHTML = "";

    // open cart if not already open
    if (document.querySelector("#miniCart:not([open])")) {
        document.querySelector("#miniCart").showModal();
    }
    document.querySelector("body").classList.add("noScroll");

    // start loading animation
    document.querySelector("#miniCartContent").classList.add("loading");

    // hide empty cart section
    document.querySelector("#miniCartEmpty").classList.remove("active");

    // hide get started section
    document.querySelector("#miniCartStart").classList.remove("active");

    // fetch cart
    if (skipFetch === false) {
        cart = await getCart();
    }

    // get cart item data
    const cartData = await fetch("/cart?view=supplemental-data")
        .then(response => response.json());
    const variantIDToSellingPlanName = cartData.variantIDToSellingPlanName;
    const variantIDToSellingPlanID = cartData.variantIDToSellingPlanID;
    const variantIDToCompareAtPrice = cartData.variantIDToCompareAtPrice;
    const variantIDToUpsell = cartData.variantIDToUpsell;

    // stop loading animation
    document.querySelector("#miniCartContent").classList.remove("loading");

    //  update cart count in header nav
    document.querySelector('#miniCartTopCount').textContent = cart.item_count;

    // check for empty cart and EXIT
    if (cart.item_count === 0) {
        document.querySelector("#miniCartEmpty").classList.add("active");
        document.querySelector("#miniCartStart").classList.add("active");
        document.querySelector("#miniCartBody").classList.remove("active");
        document.querySelector("#miniCartFooter").classList.remove("active");

        progressBar.style.width = "0%";
        shippingIcon.classList.remove("alt");
        freeGiftIcon.classList.remove("alt");
        percentageIcon.classList.remove("alt");
        if (document.querySelector('#miniCartBestsellers')) {
            document.querySelector('#miniCartBestsellers').querySelector('.miniCartBestsellersTitle').textContent = "Check Out Best Sellers";
        }
        document.querySelector('#miniCartProgressText').innerHTML = `<span>Spend $${(freeShipping / 100)} to unlock Free Shipping</span>`;

        document.querySelector('#miniCartTopCount').textContent = "";
        document.querySelector('#miniCartTopCount').classList.remove("active");
        return;
    }

    // show main cart sections
    document.querySelector("#miniCartBody").classList.add("active");
    document.querySelector("#miniCartFooter").classList.add("active");
    if (document.querySelector('#miniCartBestsellers')) {
        document.querySelector("#miniCartBestsellers").classList.add("active");
        // clear the bestsellers swiper
        document.querySelector('#miniCartBestsellers .swiper-wrapper').innerHTML = "";
    }

    // check how many subscription items are in the cart, including quantity
    let subscriptionItems = 0;
    cart.items.forEach(item => {
        if (item.selling_plan_allocation) {
            subscriptionItems += item.quantity;
        }
    });

    // append cart
    cart.items.forEach(function (item) {
        const hasProperties = item.properties && Object.keys(item.properties).length > 0;

        // variant HTML
        function variantHTML() {
            // check for default variant
            if (item.variant_title === null) {
                return "";
            }

            return `<div class="miniCartBodyItemVariant">${item.variant_title}</div>`;
        }

        let sellingPlans = [];
        const getProduct = cartData.variantIDToProduct;
        const getActiveProduct = getProduct[item.id]
        let hasPlanClass = "";

        // check if there are selling plans
        // GUARD THE FIRST GROUP TOO (16 Aug 2026): a product with no plans
        // ships selling_plan_groups = [] — truthy, so the old if passed —
        // then [0] is undefined and .forEach on it threw. The throw killed
        // the whole cart.items loop, so the drawer rendered EMPTY (badge
        // full, body blank) whenever the NEWEST cart line was a plan-less
        // product. Latent everywhere this drawer renders a mixed cart.
        (getActiveProduct?.selling_plan_groups?.[0]?.selling_plans || []).forEach(plan => {
            // append the selling plans
            sellingPlans.push({name: plan.name, id: plan.id});
        })

        // if there's a selling plan, give active class to the upgrade section
        if (item.selling_plan_allocation?.selling_plan.name) {
            hasPlanClass = "active";
        }

        // console.log(sellingPlans);

        let hasBadge = "";

        // check if the plans all have a 'Deliver Every' in their name
        if (sellingPlans.every(plan => (plan.name).includes("Deliver Every")) && hasPlanClass === 'active') {
            hasBadge = "active";
        }

        // property HTML
        function propertiesHTML() {
            // check for any properties
            if (!hasProperties) {
                return "";
            }

            // generate HTML for each item
            let HTML = `<div class="miniCartBodyItemProperties">`;
            for (const key in item.properties) {
                // check for link
                if (typeof item.properties[key] === "string" && item.properties[key].includes("https://")) {
                    HTML += `<a href="${item.properties[key]}" target="_blank">${key}</a><br>`;
                    continue;
                }

                // catch all
                HTML += `${key}: ${item.properties[key]}<br>`;
            }
            HTML += `</div>`;

            // return string
            return HTML;
        }

        // subscription HTML
        function subscriptionHTML() {
            // if there are selling plans, go through the list and add each
            if (sellingPlans && sellingPlans.length > 0) {
                return `
                <button
                    class="miniCartBodyItemUpgrade ${hasPlanClass}"                 >
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0.5" y="0.5" width="19" height="19" rx="1.5" fill="#090D1C" stroke="#090D1C"/>
                        <path d="M14 8L8.5 13L6 10.7273" fill="#090D1C"/>
                        <path d="M14 8L8.5 13L6 10.7273" stroke="white" stroke-linejoin="round"/>
                    </svg>
                
               Subscribe & Save 15%
                </button>
                <div class="miniCartBodyItemUpgradeSelectWrap">
                <div>
                  <div class="miniCartBodyItemUpgradeSelectBadge ${hasBadge}">
                 Deliver Every
                </div>
                 <button class="miniCartBodyItemUpgradeSelect" aria-label="open dropdown">
                 ${item.selling_plan_allocation?.selling_plan.name?.replace("Deliver Every", "")}
                 <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L7 7L13 1" stroke="#090D1C" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                 </button>
                        <div class="miniCartBodyItemUpgradeSelectDropdown" name="sellingPlan-"
                        aria-label="subscription select"></div>
                    </div>  
                    </div>
              
            `;
            }
            return "";
        }

        // price HTML
        function priceHTML() {
            let HTML = price(item.final_line_price);

            // there are 3 types of compare at prices (selling_plan_allocation, line item discount, compare at price)
            // calculate all 3 and the greatest one will be displayed if it is greater than the final line price
            const comparePrices = [];

            // check if selling_plan_allocation exists, if so append compare_at_price * quantity
            if (item.selling_plan_allocation) {
                comparePrices.push(item.selling_plan_allocation.compare_at_price * item.quantity);
            }

            // check for line item discount
            if (item.original_line_price > item.final_line_price) {
                comparePrices.push(item.original_line_price);
            }

            // check for compare at price
            if (variantIDToCompareAtPrice[item.variant_id]) {
                comparePrices.push(variantIDToCompareAtPrice[item.variant_id] * item.quantity);
            }

            // if there is at least one compare price
            if (comparePrices.length > 0) {
                // find the greatest compare price
                const greatestComparePrice = Math.max(...comparePrices);

                // check if the greatest compare price is greater than the final line price
                if (greatestComparePrice > item.final_line_price) {
                    HTML += `
                        <s>${price(greatestComparePrice)}</s>
                    `;
                }
            }

            return HTML;
        }

        // insert item
        document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", `
            <div class="miniCartBodyItem" data-key="${item.key}">
                <img class="miniCartBodyItemImage" src="${item.image}&width=200" alt="${item.product_title}">
                <div>
                    <div class="miniCartBodyItemFlex">
                        <div>
                            <div class="miniCartBodyItemTitle">${item.product_title}</div>
                            ${variantHTML()}
                            ${propertiesHTML()}
                        </div>
                        <button class="miniCartBodyItemRemove">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M17.3334 6.66663L6.66675 17.3333" stroke="#090D1C" stroke-linecap="square" stroke-linejoin="round"/>
                            <path d="M6.66675 6.66663L17.3334 17.3333" stroke="#090D1C" stroke-linecap="square" stroke-linejoin="round"/>
                            </svg>
                        </button>
                    </div>
                    <div class="miniCartBodyItemFlex">
                        <div class="miniCartBodyItemQuantity">
                            <button class="miniCartBodyItemQuantityMinus">-</button>
                            <div class="miniCartBodyItemQuantityCount">${item.quantity}</div>
                            <button class="miniCartBodyItemQuantityPlus">+</button>
                        </div>
                        <div class="miniCartBodyItemPrice">${priceHTML()}</div>
                    </div>
                    <div class="miniCartBodyItemBottom">
                      ${subscriptionHTML()}
                        </div>
                </div>
            </div>
        `);
        // if there are selling plans, go through the list and add each
        if (sellingPlans?.length > 0) {
            function subscriptionOptionsHTML() {
                sellingPlans.forEach((plan, index) => {
                    let option = document.createElement("label");
                    let input = document.createElement("input");
                    if (plan.name === item.selling_plan_allocation?.selling_plan.name) {
                        option.classList.add("active");
                    }
                    input.setAttribute("value", plan.id);
                    input.setAttribute("type", "radio");
                    input.setAttribute("name", plan.name?.replace("Deliver Every", ""));
                    option.textContent = plan.name?.replace("Deliver Every", "");
                    document?.querySelector(
                        `.miniCartBodyItem[data-key="${item.key}"] .miniCartBodyItemUpgradeSelectDropdown`
                    )?.appendChild(option);

                    option.appendChild(input);
                });
            }

            subscriptionOptionsHTML();
        }

        // add upsells for each item
        if (variantIDToUpsell[item.product_id]) {

            const upsells = [];
            for (let i = 0; i < variantIDToUpsell[item.product_id].length; i++) {
                if (!variantIDToUpsell[item.product_id][i].variants[0].available) continue;
                upsells.push(
                    `
                  <div class="swiper-slide">
                    <div class="miniCartBestsellersItem active" data-product="${variantIDToUpsell[item.product_id][i].id}" data-variant="${variantIDToUpsell[item.product_id][i].variants[0].id}">
                        <img class="miniCartBestsellersItemImage" src="${variantIDToUpsell[item.product_id][i].featured_image}&width=100" alt="Bestselling item image {{ forloop.index }}"/>
                        <div class="miniCartBestsellersItemContent">
                            <div class="miniCartBestsellersItemTitle">${variantIDToUpsell[item.product_id][i].title}</div>
                            <div class="miniCartBestsellersItemSize">${variantIDToUpsell[item.product_id][i].variants[0].title}</div>
                            <div class="miniCartBestsellersItemATC">
                                <div class="miniCartBestsellersItemATCPrice">${price(variantIDToUpsell[item.product_id][i].variants[0].price)}</div>
                                <button class="miniCartBestsellersItemATCButton button black" title="Add item to cart">Add</button>
                            </div>
                        </div>
                    </div>
                </div>
                    `
                )
            }
            // add to suggestions and update swiper
            document.querySelector('#miniCartBestsellers').classList.add('active');
            document.querySelector('#miniCartBestsellers .swiper-wrapper').insertAdjacentHTML('beforeend', upsells.join(''));
            // swiper.update();
        }

    });


    document.querySelectorAll('.miniCartBodyItemUpgradeSelect').forEach(button => {
        button.addEventListener('click', function () {
            button.classList.toggle('active');
        })
    });

    // event listener for each line item
    document.querySelectorAll(`.miniCartBodyItem`).forEach(function (element) {
        // get key
        let key = element.dataset.key;

        // get current quantity
        let quantity = parseInt(element.querySelector(".miniCartBodyItemQuantityCount").textContent);

        // minus
        element.querySelector(".miniCartBodyItemQuantityMinus").addEventListener("click", function () {
            if (quantity === 1) {
                element.querySelector(".miniCartBodyItemRemove").click();
            } else {
                quantity--;
                updateCartItem();
            }
        });

        // plus
        element.querySelector(".miniCartBodyItemQuantityPlus").addEventListener("click", function () {
            quantity++;
            updateCartItem();
        });

        // remove
        element.querySelector(".miniCartBodyItemRemove").addEventListener("click", function () {
            quantity = 0;
            updateCartItem();
        });

        // // setup item subscription update
        element.querySelector(".miniCartBodyItemUpgrade")?.addEventListener("click", function () {
            if (this.classList.contains("active")) {
                this.classList.remove("active");
                updateWithSubscribe(true);
                return;
            }
            this.classList.add("active");
            // make the first option selected
            this.closest('.miniCartBodyItem').querySelector('.miniCartBodyItemUpgradeSelectDropdown input').click();

        });

        // subscription select
        element
            ?.querySelector(".miniCartBodyItemUpgradeSelectDropdown")
            ?.addEventListener("change", function (event) {
                updateWithSubscribe(false, event);
            });

        async function updateWithSubscribe(unsubscribe, event) {
            let subscriptionId = null;
            if (!unsubscribe) {
                subscriptionId = event.target.value;
                event.target.closest('.miniCartBodyItem').querySelector('.miniCartBodyItemUpgradeSelect').textContent = event.target.getAttribute('name');
            }

            // update cart in shopify
            cart = await changeCart({
                id: key,
                quantity: quantity,
                selling_plan: subscriptionId,
            });

            await openCart(true);
        }


        // update quantity function
        async function updateCartItem() {
            // update label
            element.querySelector(`.miniCartBodyItemQuantityCount`).textContent = quantity;

            // start loading animation
            document.querySelector("#miniCartContent").classList.add("loading");

            // update cart in shopify
            cart = await updateCart({
                updates: {
                    [key]: quantity
                }
            });

            // update active body
            await openCart(true);
        }
    });

    // cart price totals
    if (cart.total_price < cart.items_subtotal_price) {
        document.querySelector("#miniCartFooterCheckoutPrice").innerHTML = `<span><s>${price(cart.items_subtotal_price)}</s>${price(cart.total_price)}</span>`
    } else {
        document.querySelector("#miniCartFooterCheckoutPrice").innerHTML = `<span>${price(cart.items_subtotal_price)}</span>`
    }

    // upadate the swiper best sellers
    updateBestSellers();

    // Add bestselling item function
    addUpsellListeners();

    let subtotal = cart.items_subtotal_price;
    updateProgressBar(subtotal, total);
}

// check if cart contains a bestselling item
// check if swiper has repeats as well
function updateBestSellers() {
    let swiperIds = ""
    document.querySelectorAll(".miniCartBestsellersItem")?.forEach(element => {

        // check if swiper slide exists yet
        let alreadySlide = false
        if (swiperIds.includes(element.dataset.product)) {
            alreadySlide = true;
        } else {
            swiperIds += " " + element.dataset.product;
        }

        // get the product id
        let productID = parseInt(element.dataset.product);
        let variantID = parseInt(element.dataset.variant);

        // check if exact product and variant exists within the cart
        let isProductInCart = cart.items.find(item => {
            return item.product_id === productID && item.variant_id === variantID;
        });

        // hide if already in the cart
        if (isProductInCart || alreadySlide) {
            // update title
            element.closest('#miniCartBestsellers').querySelector('.miniCartBestsellersTitle').textContent = "You May Also Like"
            element.closest(".swiper-slide").remove();
            swiper.update();
        }
    });

    // check if all bestsellers are hidden
    if (document.querySelectorAll(".miniCartBestsellersItem.active").length === 0) {
        document.querySelector("#miniCartBestsellers")?.classList.remove("active");
    }
}

// add listeners on open and reload
function addUpsellListeners() {
    document.querySelectorAll('.miniCartBestsellersItemATCButton')?.forEach(function (element) {

        element.addEventListener("click", async function () {
            // get variant ID
            const variantID = this.closest('.miniCartBestsellersItem').dataset.variant;

            // start loading animation
            document.querySelector("#miniCartContent").classList.add("loading");

            // create form data
            let formData = {
                items: [{
                    quantity: 1,
                    id: variantID,
                }]
            };

            // add bestselling product
            await addProduct(formData);

            // remove loading animation
            this.classList.remove("loading");

            await openCart();
        });
    });
}

addUpsellListeners();

// set the position of the items relative to their threshold
shippingIcon.style.left = `${(freeShipping / total) * 100}%`;
freeGiftIcon.style.left = `${(freeGift / total) * 100}%`;

function updateProgressBar(subtotal, total) {
    const progressPercentage = Math.min((subtotal / total) * 100, 100);

    const shippingDifference = freeShipping / 100 - subtotal / 100;
    const giftDifference = freeGift / 100 - subtotal / 100;
    const difference = total / 100 - subtotal / 100;

    // Update progress bar width and text content only if necessary
    if (progressBar.style.width !== `${progressPercentage}%`) {
        progressBar.style.width = `${progressPercentage}%`;
    }

    // check where the subtotal is relative to the thresholds
    const gotShipping = subtotal >= freeShipping;
    const gotGift = subtotal >= freeGift;
    const isAtTotal = subtotal >= total;


    // Determine the state of the progress bar and update text and classes accordingly
    if (gotShipping && !gotGift) {
        progressText.innerHTML = `<span>You've unlocked free shipping!
    <br/>
    <br/>
    Spend $${giftDifference.toFixed(2)} to unlock a free gift</span>`;
    } else if (gotShipping && gotGift && !isAtTotal) {
        progressText.innerHTML = `<span>You've unlocked free shipping and a free gift!
    <br/>
    <br/>
    Spend $${difference.toFixed(2)} to unlock a 10% off your entire order</span>`;
    } else if (isAtTotal) {
        progressText.innerHTML = `<span><b>You've unlocked free shipping, a free gift, and 10% off!</b></span>`;
    } else {
        progressText.innerHTML = `<span>Spend $${shippingDifference.toFixed(2)} to unlock Free Shipping</span>`;
    }

    // Update classes and styles based on the state
    shippingIcon.classList.toggle("alt", gotShipping);
    freeGiftIcon.classList.toggle("alt", gotGift);
    percentageIcon.classList.toggle("alt", isAtTotal)
}

// close event
document.querySelector("#miniCart").addEventListener("close", function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close cart function
function closeCart() {
    document.querySelector("#miniCart").close();
}

// open cart event listener
// document.querySelectorAll(".openCart").forEach(function (element) {
//     element.addEventListener("click", function (e) {
//         e.preventDefault();
//         openCart();
//     });
// });

// SANDBOX DRAWER GATE (16 Aug 2026). The binding above is commented out
// because PRODUCTION runs a third-party cart app that owns the drawer:
// it opens its own flyout on add-to-cart and on the header cart icon.
// On the sandbox that app does not exist, which left the icon dead and
// add-to-cart silent — impossible to demo or QA the cart experience.
//
// FGO_NATIVE_DRAWER is set ONLY when Shopify.shop matches a sandbox
// domain in the allowlist below. Everything that opens the native
// drawer checks this flag:
//   - the .openCart binding here (the theme's original wiring, re-enabled)
//   - main-product.js add-to-cart (its openCart call, gated)
//   - fgo-fs-cards.liquid add-to-cart (home bestseller cards)
// On production the flag is never set, so this whole feature is inert
// and the cart app keeps sole ownership — this file is safe to migrate
// as-is. If the team ever drops the cart app, adding the production
// domain to the allowlist turns the native drawer on everywhere.
var FGO_SANDBOX_SHOPS = ["fgo-nate-sandbox.myshopify.com"];
window.FGO_NATIVE_DRAWER = !!(window.Shopify && Shopify.shop && FGO_SANDBOX_SHOPS.indexOf(Shopify.shop) !== -1);
if (window.FGO_NATIVE_DRAWER) {
    document.querySelectorAll(".openCart").forEach(function (element) {
        element.addEventListener("click", function (e) {
            e.preventDefault();
            openCart();
        });
    });
}

// close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});

// close cart on overlay click
document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
})

// checkout button loading
document.querySelector("#miniCartFooterCheckout").addEventListener("click", async function () {
    this.classList.add("loading");

    // formdata
    let formData = {
        items: []
    };


    // add to cart
    if (formData.items.length > 0) {
        await addProduct(formData);
    }

    // remove loading animation
    this.classList.remove("loading");

    // go to checkout
    window.location.href = `${Shopify.routes.root}checkout`;
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#miniCart"));


// check is coming from the cart
// if (document.referrer.includes("/cart")) {
//     openCart();
// }

// bestsellers swiper
const swiper = new Swiper(document.querySelector('#miniCartBestsellers .swiper'), {
    slidesPerView: 1,
    spaceBetween: 10,
    navigation: {
        nextEl: document.querySelector('#miniCart .miniCartBestsellersButtons .swiper-button-next'),
        prevEl: document.querySelector('#miniCart .miniCartBestsellersButtons .swiper-button-prev')
    },
    pagination: {
        el: document.querySelector('#miniCart .miniCartBestsellersBar'),
        clickable: true,
    },
});